import React, { ReactNode } from 'react';
import { css } from '@emotion/css';

const styles = {
  item: css`
    @media (max-width: 668px) {
      flex-flow: row;
      align-items: center;
      grid-gap: 16px;
    }
    @media (min-width: 669px) {
      flex: 1 !important;
    }
    img {
      width: 85px;
      height: auto;
      @media (min-width: 669px) {
        width: 100%;
        max-width: 100px;
      }
    }
    > span {
      display: flex;
      &:before {
        content: '';
        min-width: 16px;
      }
    }
  `,
  count: css`
    counter-increment: idx;
    > span:before {
      content: counter(idx) '.' !important;
    }
  `,
  orderedList: css`
    counter-reset: idx;
    @media (min-width: 669px) {
      &.two-items {
        .grid-item:nth-child(2) {
          flex-direction: column;
          align-items: center;
          text-align: center;
          > span:before {
            display: block;
            min-width: 100%;
            margin-bottom: 8px;
          }
        }
      }
    }
  `,
};

interface OrderedListProps {
  children: ReactNode;
}

export const OrderedList = ({ children }: OrderedListProps) => {
  const childCount = React.Children.count(children);
  const twoItemsClass = childCount === 2 ? 'two-items' : '';

  return (
    <div className={`grid grid-flex grid-align-start gutter-xl order-list ${styles.orderedList} ${twoItemsClass}`}>
      {children}
    </div>
  );
};

interface OrderedListItemProps {
  image: ReactNode;
  text: ReactNode;
  omit?: boolean;
}

const OrderedListItem = ({ image, text, omit = false }: OrderedListItemProps) => (
  <div className={`grid-item grid grid-flex grid-justify-center ${styles.item} ${!omit && styles.count}`}>
    <div className='grid-item'>{image}</div>
    <span className='grid-item'>
      <div>{text}</div>
    </span>
  </div>
);

OrderedList.Item = OrderedListItem;

export default OrderedList;
